import * as types from './types';
import { getFullCadessStatus, getFullCaseStatus } from '../../communication/CadessAPICommun';
import { updateCadessImageOfSelectedSpecimen } from './SpecimenActions';

export const resetCadessData = () => dispatch => {
  dispatch({ type: types.CLEAR_CADESS_DATA });
};

export const updateCadessDataForSpecimen = (specimen) => async dispatch => {
  dispatch(resetCadessData());
  getFullCadessStatus(specimen.cadessId)
    .then(data => {
      dispatch({ type: types.SET_CADESS_DATA, payload: data });
      if (data.CADESS_image !== specimen.cadessImgUrl) {
        dispatch(updateCadessImageOfSelectedSpecimen(data.CADESS_image, specimen));
      }
    })
    .catch(e => console.log(e));
};

export const updateCadessDataForCase = (specimens) => async dispatch => {
  dispatch(resetCadessData());
  console.log(specimens);
  const specimen_ids = specimens
    .map(t => t.cadessId)
    .join(",");
  getFullCaseStatus(specimen_ids)
    .then(data => {
      dispatch({ type: types.SET_CADESS_DATA, payload: data });
    })
    .catch(e => console.log(e));
};
